import { Box } from '@chakra-ui/react';
import { NestedHome } from '@habity/types';
import { getTitle } from '~/lib/homes/profile/description';
import { isSellerClaimed } from '@habity/services';
import { isAdmin } from '~/lib/roles';
import { useUser } from '~/hooks/useUser';
import { useHomes } from '~/hooks/useHomes';
import { InlineEditor } from '~/components/ui/InlineEditor';

export const ProfileTitle = ({ home }: { home: NestedHome }) => {
  const { user } = useUser();
  const { updateHome } = useHomes();

  const canEditTitle = isAdmin(user) && home && isSellerClaimed(home);

  if (getTitle(home) === '') {
    return null;
  }

  return (
    <Box width="100%">
      <InlineEditor
        value={getTitle(home) || ''}
        onSave={async (value) => {
          if (home?.id) {
            await updateHome(home.id, {
              title: value,
            });
          }
        }}
        placeholder="Ange en titel för bostaden"
        canEdit={canEditTitle}
        textProps={{
          size: { mobile: '3xl', desktop: '6xl' },
          letterSpacing: { desktop: '-3px' },
          lineHeight: { mobile: '14px', desktop: 1 },
          mt: { mobile: '5', desktop: '0' },
          mb: !isSellerClaimed(home) ? '4' : '0',
          sx: {
            // Firefox-specific fix for line height rendering
            '@-moz-document url-prefix()': {
              lineHeight: { mobile: '1.2', desktop: '1.1' },
            },
          },
        }}
        inputProps={{
          size: 'lg',
          fontSize: { mobile: '3xl', desktop: '6xl' },
          letterSpacing: { desktop: '-3px' },
          lineHeight: { desktop: 1.11 },
          mt: { mobile: '5', desktop: '0' },
          mb: '4',
          placeholder: 'Ange en titel för bostaden',
          sx: {
            // Firefox-specific fix for line height rendering
            '@-moz-document url-prefix()': {
              lineHeight: { mobile: '1.2', desktop: '1.1' },
            },
          },
        }}
      />
    </Box>
  );
};
